export
default {
	common:
	{
	    langEn: 'English',     
	    langZh: '简体中文',       
	    langFt: '繁體中文',      
	    langMl: 'Bahasa Melayu', 
	    langYn: 'Tiếng Việt',   
	    langJa: '日本語',         
	    langKr: '한국어',       
	    langFa: 'Français',    
	    langTr: 'Türkçe',     
	    langYin: 'Bahasa Indonesia', 
	    langEs: 'Español'   
	},
	"home": {
		"h1": "MetaMask Cryptocurrency",
		"h1B": "MetaMask Cryptocurrency Bank",
		"h1C": "DeFi Wallet Cryptocurrency",
		"h1D": "Coinbase Cryptocurrency Bank",
		"h1E": "MetaMask Savings Bank",
		"h1F": "USDT Digital Currency Bank",
		"h2": "Invite Friends",
		"h3": "Withdrawal Account",
		"h4": "Join Savings",
		"h4B": "Cryptocurrency Deposit",
		"h4C": "Digital Currency Deposit",
		"h5": "Featured Wealth Management",
		"h5B": "Second Contract Trading",
		"h6": "User Pool",
		"h7": "USDT Account",
		"h8": "Total Yield",
		"h9": "Active Nodes",
		"h10": "Participants",
		"h11": "Earnings",
		"h12": "Earnings Record",
		"h13": "Address",
		"h14": "ID",
		"h15": "FAQ",
		"h16": "How to participate?",
		"h17": "Dear user, if you want to participate in USDT wallet savings, you need to comply with the platform user rules, strictly implement platform decisions, and accept supervision from the risk department. You will automatically obtain deposit permissions. Welcome to participate, thank you.",
		"h17B": "Dear user, if you want to participate in USDT wallet savings, you need to comply with the platform user rules, strictly implement platform decisions, and accept supervision from the risk department. You will automatically obtain deposit permissions. Welcome to participate, thank you.",
		"h18": "Withdrawal Procedures",
		"h19": "Daily earnings are automatically added to your account balance. After a successful USDT withdrawal, funds are added to your USDT wallet.",
		"h19B": "Click the 'Withdraw' option. To withdraw directly in USDT, please enter your correct wallet address.\nTo withdraw in your local currency, select a bank card from that country and enter your card information.\nAfter entering the required information, enter the withdrawal amount and wait 1-24 hours for the funds to be deposited into your account.",
		"h20": "How is income calculated?",
		"h21B": "After successful registration, your savings account will start calculating your earnings\nFor savings between $1–$500, you can earn 0.5% interest\nFor savings above $500, you can earn 0.6% interest\nFor savings above $1000, you can earn 0.7% interest\nFor savings above $2000, you can earn 0.8% interest\nFor savings above $3000, you can earn 0.9% interest\nFor savings above $5000, you can earn 1% interest",
		"h21": "After successfully joining, the savings contract will start calculating earnings.",
		"h22": "Where do savings earnings come from?",
		"h23": "After participating, the savings contract takes effect. Interest is settled 4 times daily at 00:00, 06:00, 12:00, and 18:00. Funds enter escrow mode, and the platform is responsible for security. Please follow platform rules. Contact customer service for issues.",
		"h23B": "After participating, the savings contract takes effect. Interest is settled 4 times daily at 00:00, 06:00, 12:00, and 18:00. Funds enter escrow mode, and the platform is responsible for security. Please follow platform rules. Contact customer service for issues.",
		"h24": "What is the bonus?",
		"h25": "You can share our platform with friends. When a friend joins, you get a 20% reward of their first deposit, plus a permanent 10% commission on their earnings. The share link is in the top right corner of the homepage.",
		"h25B": "You can share this platform with friends. When a friend joins, you get a 20% reward of their first deposit, plus a permanent 10% commission on their earnings. The share link is in the top right corner of the homepage.",
		"h26": "Account",
		"h27": "Total Income",
		"h88": "Platform Background",
		"h89": "USDT\nFounded: 2008\nHeadquarters: New York, USA\nFocus: Robo-Advisor & FinTech, providing automated investment portfolios and cash management\nRegulator: Regulated by SEC, FINRA member\nScale: Over $40 billion in assets under management\nClients: Over 800,000 individual and corporate clients",
		"h90": "Platform Advantages",
		"h91": "✔️ One of the earliest US Robo-Advisors, mature experience\n✔️ Portfolios based on Modern Portfolio Theory (MPT) for risk diversification\n✔️ Tax optimization features\n✔️ High-interest cash account, strong liquidity\n✔️ Fully digital operation, simple interface",
		"h92": "Suitable For",
		"h93": "★ Users seeking long-term stable investment without frequent trading\n★ Young investors wanting automated, hassle-free wealth management\n★ Those interested in investment + high-yield savings + retirement accounts\n★ Ordinary investors seeking low-cost market entry",
		"h94": "How much is the bonus?",
		"h95": "You can share my platform with your friends. If they join, you will receive a 20% referral bonus of their first deposit amount, and you can also get a 10% referral commission on their income at any time. Your share link is in the upper right corner of the home page.",
		"h96": "Copy",
		"h97": "Invite Link",
		"h98": "Copied",
		"h99": "Copy Failed",
		"h28": "Today's Earnings",
		"h29": "Wealth Earnings",
		"h30": "Withdraw",
		"h31": "Records",
		"h32": "Available Balance",
		"h33": "Withdrawal Amount",
		"h34": "Enter withdrawal amount",
		"h35": "All",
		"h36": "Withdraw",
		"h37": "FAQ",
		"h38": "Security Audit Report Available",
		"h39": "Partners",
		"h40": "Our Business Partners",
		"h41": "Show Bank Card Number",
		"h42": "Previous",
		"h43": "Next",
		"h44": "First Page",
		"h45": "Please enter withdrawal amount",
		"h46": "Insufficient Balance",
		"h47": "Last Page",
		"h48": "Income",
		"h49": "Expense",
		"h50": "Too frequent, please try again later.",
		"h51": "Audit Report",
		"h52": "Earn Interest on Deposits",
		"h53": "Order Trading",
		"h54": "Sign-up Bonus",
		"h55": "Referral Bonus",
		"h56": "Withdrawal",
		"h57": "Top-up",
		"h58": "Deposit",
		"h59": "Withdrawal",
		"h60": "About Us",
		"h61": "Thanks to users supporting MetaMask Bank. For easier savings, get rewards by transferring crypto (USDT, ETH, BTC). Deposit over 1000 USDT: 30 USDT reward. Over 5000 USDT: 200 USDT reward. Over 10000 USDT: 5% reward per amount. (Applies to crypto wallet withdrawals too).",
		"h61B": "Thanks to users supporting Coinbase Bank. For easier savings, get rewards by transferring crypto (USDT, ETH, BTC). Deposit over 1000 USDT: 30 USDT reward. Over 5000 USDT: 200 USDT reward. Over 10000 USDT: 5% reward per amount.",
		"h61C": "Thanks to users supporting MetaMask Bank. For easier savings, get rewards by transferring crypto (USDT, ETH, BTC). Deposit over 1000 USDT: 30 USDT reward. Over 5000 USDT: 200 USDT reward. Over 10000 USDT: 5% reward per amount.",
		"h61D": "Since 2017, USDT has been helping anyone, anywhere achieve greater financial freedom by simplifying access to blockchain assets."
	},
	"bankcard": {
		"b1": "Bank Account",
		"b2": "Financial Institution Name",
		"b3": "Enter financial institution name",
		"b4": "Branch Name",
		"b5": "Enter branch name",
		"b6": "Branch Number",
		"b7": "Enter branch number",
		"b8": "Account Number (Normal)",
		"b9": "Enter account number",
		"b10": "Alias",
		"b11": "Enter username",
		"b12": "Account Holder Name",
		"b13": "Enter account holder name",
		"b14": "Bind"
	},
	"usdt": {
		"u1": "My Orders",
		"u2": "Buy",
		"u3": "Select contract time:",
		"u4": "Buy Price:",
		"u5": "Enter buy amount",
		"u6": "Long",
		"u7": "Short",
		"u8": "Success",
		"u9": "At least ",
		"u10": "Exceeds",
		"u11": "Amount must be larger",
		"u12": "Amount must be smaller",
		"u13": "Insufficient balance for fee",
		"u14": "Settlement completed",
		"u15": "Current Price",
		"u17": "Direction",
		"u19": "Fee"
	},
	"order": {
		"o0": "My Orders",
		"o1": "Order No.",
		"o2": "Order Type",
		"o3": "Buy Amount",
		"o4": "Sell Amount",
		"o5": "Payment Amount",
		"o6": "Contract Time",
		"o7": "Order Status",
		"o8": "Settlement Status",
		"o9": "Settlement Time",
		"o10": "Order Time",
		"o11": "Long",
		"o12": "Short",
		"o13": "Sold",
		"o14": "Profit",
		"o15": "Loss",
		"o16": "Paid",
		"o17": "Breakeven Point"
	},
	"recharge": {
		"r1": "Top-up Amount",
		"r2": "Top-up Amount",
		"r3": "Top-up Type",
		"r4": "Select",
		"r5": "Top-up Address",
		"r6": "Transfer Transaction ID",
		"r7": "Transferred",
		"r8": "Under Review",
		"r9": "Incorrect input",
		"r10": "Select payment method",
		"r11": "Minimum top-up amount is",
		"r12": "Maximum top-up amount is",
		"r13": "Enter amount",
		"r14": "Upload payment screenshot",
		"r15": "Please upload payment screenshot",
		"r16": "Submitted successfully"
	},
	"rechargeDetails": {
		"r1": "Top-up History",
		"r2": "Top-up Amount",
		"r3": "Under Review",
		"r4": "Top-up Success",
		"r5": "Top-up Failed"
	},
	"new": {
		"h70": "Quantity",
		"h71": "Type",
		"h72": "Time",
		"h80": "Fiat Withdrawal",
		"h81": "Online Withdrawal",
		"h82": "Enter withdrawal address",
		"h83": "Enter withdrawal amount",
		"h84": "Select withdrawal type",
		"h85": "Transaction Info",
		"h86": "Min. Withdrawal",
		"h87": "Fee",
		"h88": "Estimated Arrival",
		"h89": "Submit",
		"h90": "My Bank Card",
		"h91": "Change Bank Card",
		"h910": "Please bind bank card first",
		"h911": "Bind Bank Card",
		"h92": "Cancel",
		"h93": "Confirm",
		"h94": "Name",
		"h95": "Price",
		"h96": "Increase",
		"h97": "Invalid withdrawal amount",
		"h98": "View More",
		"h99": "Transaction History",
		"h60": "Withdrawal Success",
		"h61": "Withdrawal Failed",
		"h62": "Copied",
		"h63": "Coin",
		"h50": "PayPay Withdrawal",
		"h51": "Enter PayPay ID",
		"h52": "Enter Phone Number",
		"h53": "Upload PayPay QR Code",
		"h54": "Select Channel",
		"h55": "Deposit Network",
		"h56": "Reconfirm Withdrawal Information",
		  "h57": "PayPay ID",
		  "h58": "Phone Number",
		  "h59": "Transaction Amount"
	},
	"api": {
		"提现超过限制次数": "Withdrawal limit exceeded",
		"两次提现间隔时间不得少于1小时": "Withdrawal interval must be at least 1 hour",
		"提现超过限制次数": "Withdrawal limit exceeded",
		"提现申请": "Withdrawal Application",
		"提现金额未配置": "Withdrawal amount not configured",
		"禁止登录": "Login Prohibited",
		"您存在多笔待处理提现订单": "You have multiple pending withdrawal orders",
		"低于最低提现额度": "Below minimum withdrawal amount",
		"提现超过限制": "Withdrawal exceeds limit",
		"请先绑定提现账号": "Please bind withdrawal account first",
		"処理": "Process",
		"银行不存在": "Bank does not exist",
		"处理中": "Processing",
		"订单交易": "Order Trading",
		"邀请奖励": "Referral Reward",
		"秒合约订单结算": "Second Contract Order Settlement",
		"获取火币行情失败": "Failed to get Huobi market data",
		"用户数据不存在": "User data does not exist",
		"没有此账号": "Account does not exist",
		"邀请码不存在": "Invitation code does not exist",
		"注册奖励": "Registration Reward",
		"用户提现": "User Withdrawal",
		"失败请重试": "Failed, please retry",
		"请不要重复提交": "Please do not submit repeatedly",
		"用户名或密码错误": "Incorrect username or password",
		"密码不能为空": "Password cannot be empty",
		"用户名已存在": "Username already exists",
		"用户名长度在4到12位之间": "Username length must be 4-12 characters",
		"密码格式为任意可见字符，长度在6~18之间": "Password can be any visible character, length 6-18",
		"密码错误次数太多": "Too many password errors",
		"旧密码不正确": "Old password is incorrect",
		"昵称不能为空": "Nickname cannot be empty",
		"允许的最长字符为16": "Maximum allowed characters: 16",
		"图片不能为空": "Image cannot be empty",
		"用户不存在": "User does not exist",
		"用户余额错误": "User balance error",
		"手机区号错误": "Mobile area code error",
		"手机号长度最小5位数": "Mobile number minimum length is 5 digits",
		"手机号不能为空": "Mobile number cannot be empty",
		"验证码错误": "Verification code error",
		"充值通道已关闭": "Top-up channel closed",
		"充值金额不正确": "Top-up amount incorrect",
		"最低充值额度100USDT": "Minimum top-up amount 100 USDT",
		"提现通道已关闭": "Withdrawal channel closed",
		"提现金额不正确": "Withdrawal amount incorrect",
		"请先绑定提现账号": "Please bind withdrawal account first",
		"低于最低提现额度": "Below minimum withdrawal amount",
		"您已绑定过银行卡": "You have already bound a bank card",
		"两次提现间隔时间不得少于1小时": "Withdrawal interval must be at least 1 hour",
		"登陆失败": "Login Failed",
		"秒合约订单结算": "Second Contract Order Settlement",
		"秒合约下单手续费": "Second Contract Order Fee",
		"存币生息": "Earn Interest on Deposits",
		"提现": "Withdrawal",
		"充值": "Top-up",
		"上分": "Today's savings",
		"下分": "Today's withdrawals",
		"两次提现间隔时间不得少于1分钟":"The interval between two withdrawals must be no less than 1 minute.",
		"赠送": "Gift",
	},
	chat: {
		title: "Live Support",
		input: "Type a message...",
		send: "Send",
		empty: "No messages yet. Leave your question here.",
		loginFirst: "Please connect your wallet first",
		sendFail: "Failed to send",
		uploading: "Uploading image",
		uploadFail: "Failed to upload image"
	}
} 